import { render } from "./addslot.vue?vue&type=template&id=e8afabac&scoped=true"
import script from "./addslot.vue?vue&type=script&lang=js"
export * from "./addslot.vue?vue&type=script&lang=js"

import "./addslot.vue?vue&type=style&index=0&id=e8afabac&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8afabac"]])

export default __exports__